import React, { useEffect, useState, useRef, useContext } from "react";
import CardWithText from "../../components/Cards/CardWithText";
import images from "../../utils/images";
import axiosInstance from "../../services/api/axiosInstance"
import toast from "react-hot-toast";
import { IoIosInformationCircleOutline } from "react-icons/io";
import CommonContext from "../../hooks/CommonContext";


const Pricing = () => {

  const { country,
    setCountry,
    countryLoading,
    setCountryLoading,
    checkOutStatus,
    setCheckOutStatus,
    subscriptionExpiredShow } = useContext(CommonContext)


  const [data, setData] = useState([
    "Get access to our community of 50+",
    "Matching Priority",
    "Recommendation Strategy",
    "Personal advisor to advise, coach and plan your future",
    "Resume and LinkedIn Review and Update",
    "Psychometric assessment",
    "",
    "Mock Interviews",
  ]);

  return (

    <div className="pricing-plan">
      <section className="pt-5">
        <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3 g-4 col-lg-11 col-xl-10 col-xxl-9 mx-auto pt-3">
          <div className="w-100 text-center mt-4">
            <span className="fs-3 fw-bold">Pricing plan</span>
            <span className="ms-4 d-block">
              <img
                src={images.underline}
                alt="underline"
                className="img-responsive logo"
              />
            </span>
          </div>

          <div className="col">
            <CardWithText
              cardTitle="Basic"
              cardPrice={country === "India" ? process.env.REACT_APP_BASIC_RUPEES : process.env.REACT_APP_BASIC_DOLLARS}
              // cardPrice="Free"
              countryLoading={countryLoading}
              cardContent_1="Yes"
              cardContent_2="Basic - AI will recommend your profile to employers if there is a match"
              cardContent_3="Receive job recommendations from AI"
              cardContent_4="One 30-minute interaction with an advisor"
              cardContent_5=""
              cardContent_6=""
              cardContent_7=""
              cardContent_8=""
              cardBtnName={checkOutStatus.paymentStatus === "trialing" && checkOutStatus.productPlan === "Basic" ? "Free" : "Free"}
              plan="Basic"
              planPhase="Professional"
              planKey={country === "India" ? process.env.REACT_APP_PLAN_BASIC : process.env.REACT_APP_PLAN_BASIC_US}
              currentPlan={checkOutStatus.paymentStatus === "trialing" || checkOutStatus.paymentStatus === "complete" && checkOutStatus.productPlan === "Basic"}
              checkOutStatus={checkOutStatus}
              questionArray={data}
              subscriptionExpiredShow={subscriptionExpiredShow}
            />
          </div>

          <div className="col">
            <CardWithText
              cardTitle="Premium"
              cardPrice={country === "India" ? process.env.REACT_APP_PREMIUM_RUPEES : `$${process.env.REACT_APP_PREMIUM_DOLLARS}`}
              countryLoading={countryLoading}
              cardContent_1="Yes"
              cardContent_2="Priority Matching - 2nd Careers will provide top-up AI recommended matches of your profile if there is a match "
              cardContent_3="Personalized job recommendation from 2nd Careers team in addition to AI recommendations"
              cardContent_4="Two 1:1 career coaching interactions with 2nd Careers advisor"
              cardContent_5="Yes"
              cardContent_6=""
              cardContent_7=""
              cardContent_8=""
              cardBtnName="Coming soon"
              plan="Premium"
              planPhase="Professional"
              planKey={country === "India" ? process.env.REACT_APP_PLAN_PREMIUM : process.env.REACT_APP_PLAN_PREMIUM_US}
              currentPlan={checkOutStatus.paymentStatus === "complete" && checkOutStatus.productPlan === "Premium"}
              checkOutStatus={checkOutStatus}
              questionArray={data}
              subscriptionExpiredShow={subscriptionExpiredShow}
            />
          </div>

          <div className="col">
            <CardWithText
              cardTitle="Platinum"
              cardPrice={country === "India" ? process.env.REACT_APP_PLATINUM_RUPEES : `$${process.env.REACT_APP_PLATINUM_DOLLARS}`}
              countryLoading={countryLoading}
              cardContent_1="Yes"
              cardContent_2="Priority Matching - 2nd Careers will provide top-up AI recommended matches of your profile if there is a match "
              cardContent_3="Personalized job recommendation from 2nd Careers team in addition to AI recommendations"
              cardContent_4="Two 1:1 career coaching interactions with 2nd Careers advisor"
              cardContent_5="Yes"
              cardContent_6="One psychometric assessment and briefing session with certified coach"
              cardContent_7=""
              cardContent_8="Mock interview with 2nd Career advisor"
              cardBtnName="Coming soon"
              plan="Platinum"
              planPhase="Professional"
              planKey={country === "India" ? process.env.REACT_APP_PLAN_PLATINUM : process.env.REACT_APP_PLAN_PLATINUM_US}
              currentPlan={checkOutStatus.paymentStatus === "complete" && checkOutStatus.productPlan === "Platinum"}
              checkOutStatus={checkOutStatus}
              questionArray={data}
              subscriptionExpiredShow={subscriptionExpiredShow}
            />
          </div>

          <div className="text-center w-100 fw-medium cardCopyRight mt-5">
            <span className="d-block mb-1">
              Copyright &copy; 2024 | Powered by 2nd Careers
            </span>
            <span className="d-block mb-3"><span className="cursorPointer"  onClick={()=> window.open("https://2ndcareers.com/terms-and-conditions/","_blank")}>Terms&nbsp;and&nbsp;conditions
            </span> | <span className="cursorPointer" onClick={()=> window.open("https://2ndcareers.com/privacy-policy/","_blank")}>Privacy policy</span></span>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Pricing;